// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__3usaY","author":"Table_author__2e7tS","authorImage":"Table_authorImage__jSCWs","unreadRow":"Table_unreadRow__3cK1n"};